package com.klantenstop.web.pages.authentication.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.Span
import org.w3c.dom.HTMLSpanElement

@Composable
fun AuthenticationContainer(
    title: String,
    content: @Composable () -> Unit,
    footer: ContentBuilder<HTMLSpanElement>? = null
) {
    val breakpoint = rememberBreakpoint()

    Box(
        modifier = Modifier.fillMaxSize().padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {

        Column(
            modifier = Modifier
                .minWidth(
                    when (breakpoint) {
                        Breakpoint.XL, Breakpoint.XXL,
                        Breakpoint.LG, Breakpoint.MD -> 450.px

                        else -> 0.px
                    }
                )
                .fillMaxWidth(
                    when (breakpoint) {
                        Breakpoint.XL, Breakpoint.XXL -> 33.percent
                        Breakpoint.LG, Breakpoint.MD -> 50.percent
                        Breakpoint.SM -> 77.percent
                        else -> 90.percent
                    }
                )
                .padding(24.px)
                .backgroundColor(MaterialColorVars.SurfaceVariant.value())
                .borderRadius(20.px)
                .border(1.px, style = LineStyle.Solid, color = MaterialColorVars.OutlineVariant.value()),
            verticalArrangement = Arrangement.spacedBy(24.px, Alignment.CenterVertically),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                modifier = Modifier
                    .fontSize(24.px)
                    .lineHeight(32.px),
                text = title
            )

            content()

            footer?.let {
                HorizontalDivider(modifier = Modifier.fillMaxWidth())

                Span(
                    attrs = Modifier
                        .textAlign(TextAlign.Center)
                        .fillMaxWidth()
                        .fontSize(16.px)
                        .lineHeight(18.px)
                        .toAttrs(),
                    content = footer
                )
            }
        }
    }
}
